import { Paper } from '@material-ui/core';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import Authorize from 'components/Authorize';
import { permissionProfiles } from 'components/Authorize/permissionProfiles';
import { vehicleGradeCardStyle } from './VehicleGradeCardStyle';

const MAX_STARS = 5;

const GradeStars = ({ grade }) => {
    const classes = vehicleGradeCardStyle();
    return (
        <div className={classes.starsRow}>
            {Array.from({ length: MAX_STARS }, (_, i) => {
                const full = grade >= i + 1;
                const half = !full && grade >= i + 0.5;
                if (full) return <StarIcon key={i} />;
                if (half) return <StarHalfIcon key={i} />;
                return <StarBorderIcon key={i} />;
            })}
        </div>
    );
};

const VehicleGradeCard = ({ vehicleDetails }) => {
    const classes = vehicleGradeCardStyle();
    const grade = vehicleDetails?.grade;

    return (
        <Authorize profile={permissionProfiles.REMARKETING.VIEW_VEHICLE_GRADE}>
            <Paper className={classes.card}>
                <div className={classes.label}>Vehicle Grade</div>
                {grade != null ? (
                    <>
                        <div className={classes.gradeNumber}>{grade.toFixed(1)}</div>
                        <GradeStars grade={grade} />
                        <div className={classes.outOf}>out of {MAX_STARS}.0</div>
                    </>
                ) : (
                    <div className={classes.pendingText}>Pending SAMA Appraisal</div>
                )}
            </Paper>
        </Authorize>
    );
};

export default VehicleGradeCard;
